
import { PatientDto, GeneralPractitioner } from "../../../dto/PatientDto";

export class PatientRoundViewModel {
    constructor() {
    }
    public DispensationDate: Date;
    public patient: PatientDto;
    public groups: Map<string, number>;
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/PatientMarHistory/PatientRoundViewModel.ts